import React from "react";
import { PropsType } from "./type";

export default function Image(props: PropsType) {
  const { containerClass, onClick, alt = "", ...restProps } = props;

  return <img {...restProps} alt={alt} loading="lazy" onClick={onClick} />;
}
